/*****************************************************************************************
 * 설명 : 관리자 > 컨텐츠관리 > 컨텐츠 설정
 * URI : /admin/cms/menuList
*****************************************************************************************/
import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import * as Yup from "yup";

import { ButtonEx } from 'components/inputEx';
import alertMsg from 'components/message';

import { Restful } from 'service/restful';

import { MESSAGE_DELAY } from 'config/config';

/*****************************************************************************************
 * 설명 : 함수 선언
*****************************************************************************************/
const TabContents = ( props ) => {

  /***************************************************************************************
   * 설명 : 변수 선언부
  ***************************************************************************************/
	const [getApi] = Restful();
	const [contents, setContents] = useState('<p>내용을 입력해 주시기 바랍니다.</p>');

	// const noteRef = useRef();

	const initValues = {
		seq: '',
		siteSeq: '',
		contents: ''
	}

  const formik = useFormik({
		initialValues: initValues,
		validationSchema: Yup.object().shape({
		}),
		onSubmit: (values) => {
			let params = {
        program: 'api',
        service: 'cms',
        action: 'setMenuContents',
        version: '1.0',
        seq: props.data.seq,
				siteSeq: props.siteSeq,
				contents: contents
      }

			getApi("post", params).then( response => {
        if( response !== undefined && response.data.result ) {
          alertMsg(response.data.message, "S", MESSAGE_DELAY);

					if( props.menuList && props.setMenuList ) {
						let tmp = findMenuTree(props.menuList, props.data.pageCode);
						tmp.contents = contents;
					}

        } else {
          alertMsg(response.data.message, "E", MESSAGE_DELAY);
        }
      });
		}
  });

	/***************************************************************************************
   * 설명 : 트리 메뉴 구성 시 부모 트리 찾기
  ***************************************************************************************/
  const findMenuTree = (menuList, pageCode) => {
    var result;
    menuList.some(o => result = o.pageCode === pageCode ? o : findMenuTree(o.children || [], pageCode));
    return result;
  }

	/***************************************************************************************
   * 설명 : 데이터 처리
  ***************************************************************************************/
  useEffect(() => {
		if( props.tabIndex === 1 && props.siteSeq !== '' ) {
			formik.setFieldValue('siteSeq', props.siteSeq );
		}

		// eslint-disable-next-line
  }, [props.siteSeq]);

	/***************************************************************************************
   * 설명 : 등록/수정 시 처리
  ***************************************************************************************/
  useEffect(() => {
    if( props.tabIndex === 1 && props.data !== undefined && props.data !== null ) {
			const tmp = props.data.contents === '' || props.data.contents === null || props.data.contents === undefined ? '<p>내용을 입력하시기 바랍니다.</p>' : props.data.contents;
			setContents(tmp);
    }

    // eslint-disable-next-line
  }, [props.data, props.tabIndex]);


  /***************************************************************************************
   * 설명 : html 선언부
  ***************************************************************************************/
  return (
		<>
			{ props.siteSeq === '' &&
        <section className="pt10">
          <div className="menu-list-add-background">
            사이트를 선택 후에 '메뉴등록' 혹은 '메뉴선택'을 진행해주세요.
          </div>
        </section>
      }

			{props.siteSeq !== '' &&
				<>
					{(props.data.seq === undefined || props.data.siteSeq === undefined ) &&
						<section className="pt10">
							<div className="menu-list-add-background">
								메뉴를 선택하시기 바랍니다.
							</div>
						</section>
					}
					{props.data.seq !== undefined && props.data.siteSeq !== undefined &&
						<section className="pt10">
							<form onSubmit={formik.handleSubmit}>
								<header>
									<div className="right">
										<ButtonEx
											title="컨텐츠 저장"
											auth="authWrite"
											type="submit"
											color="primary"
											variant="contained"
											className="Btn"
										/>
									</div>
								</header>

								<div className="mt10" style={{width: 'calc(100% - 2px)'}}>
									<div id="CKEditor" className="mt5">
										<CKEditor
											editor={ Editor }
											data={ contents }
											config={{
												htmlSupport: {
													allow: [
														{ // to keep all the html tags and their attributes
																name: /.*/,
																attributes: true,
																classes: true,
																styles: true
														},
														{
																name: 'a',
																attributes: {
																	target: true
																}
														}
													]
												}
											}}
											onReady={ editor => {
												// You can store the "editor" and use when it is needed.
											}}
											onChange={ ( event, editor ) => {
												const text = editor.getData();
												setContents(text);
											}}
											onBlur={ ( event, editor ) => {
												const text = editor.getData();
												setContents(text);
											}}
											onFocus={ ( event, editor ) => {
											}}
										/>
									</div>
									{/*
									<Summernote
										ref={noteRef}
										defaultCodeValue={contents}
										placeholder={"내용을 입력해 주시기 바랍니다."}
										tabsize={2}
										lang="ko-KR" // only if you want to change the default language
										height={550 || "70vh"}
										dialogsInBody={true}
										blockquoteBreakingLevel={0}
										toolbar={[
											['style', ['style']],
											['font', ['bold', 'underline', 'clear', 'strikethrough', 'superscript', 'subscript']],
											['fontsize', ['fontsize']],
											['fontname', ['fontname']],
											['color', ['color']],
											['para', ['ul', 'ol', 'paragraph']],
											['table', ['table']],
											['insert', ['link', 'picture', 'video', 'hr']],
											['view', ['fullscreen', 'codeview', 'help']]
										]}
										fontNames={[
											"Arial",
											"Georgia",
											"Verdana",
											"e.t.c..."
										]}
										callbacks={{
											onChange: function(contents, $editable) {
												setContents(contents);
											},
											onInit: function() {
												noteRef?.current?.summernote('insertText', contents)
											}
										}}
									/>
									*/}
								</div>
							</form>
						</section>
					}
				</>
			}
		</>
  );
}

/*****************************************************************************************
 * 설명 : default export 선언
*****************************************************************************************/
export default TabContents;